import './App.css';
import { Link, HashRouter as Router, Route, Routes } from "react-router-dom";
import StarGamepage from "./components/StarGamepage";
import DarkStarGamepage from "./components/DarkStarGamepage";
import Login from "./components/Login";
import DarkLogin from "./components/DarkLogin";
import LandingPage from "./components/LandingPage";
import SoulMusic from './HW4components/SoulMusic';
import DarkSoulMusic from './HW4components/DarkSoulMusic';
import HW3LandingPage from './components/HW3LandingPage';
import Checkout from './HW4components/Checkout';

function App() {
  return (
    <>
      <Router>
        <div className="App" >
          <Link to = "/">
            Home
          </Link>
          <div>
            <Routes>
                <Route 
                  path="/StarGamepage"
                  element={
                    <StarGamepage initialView='game'/>
                  }
                />
                <Route 
                  path="/DarkStarGamepage"
                  element={
                    <DarkStarGamepage/>
                  }
                />
                <Route 
                  path = "/Login" 
                  element={<Login/>}
                />
                <Route 
                  path = "/DarkLogin" 
                  element={<DarkLogin/>}
                />
                <Route 
                  path = "/" 
                  element={<LandingPage/>}
                />
                <Route
                  path = "/SoulMusic"
                  element={<SoulMusic/>}
                />
                <Route
                  path = "/DarkSoulMusic"
                  element={<DarkSoulMusic/>}
                />
                <Route
                  path = "/Checkout"
                  element={<Checkout/>}
                />
                <Route 
                  path = "/HW3LandingPage" 
                  element={<HW3LandingPage/>}
                />
              
            </Routes>
          </div>
        </div>
      </Router>
    </>
  );
}

export default App;
